import { render, staticRenderFns } from "./IntegrationInfo.vue?vue&type=template&id=9b843618&"
import script from "./IntegrationInfo.vue?vue&type=script&lang=js&"
export * from "./IntegrationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports